import React, { useCallback } from "react";
import { createForm } from "@formily/core";
import { createSchemaField } from "@formily/react";
import { Form, FormItem, Input, Submit, FormButtonGroup } from "@formily/antd";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Card, message, Space } from "antd";
import { useAuthContext } from "@/components/auth/AuthProvider";
import { user as userService } from "@/services";
import CodeInput from "./CodeInput";
import styles from "./index.module.less";

const normalSchema = {
  type: "object",
  properties: {
    phone: {
      type: "string",
      title: "联系人电话",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        disabled: true,
      },
    },
    code: {
      type: "string",
      title: "验证码",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "CodeInput",
      "x-component-props": {
        placeholder: "请输入验证码",
        token: "{{{token}}}",
      },
      "x-reactions": [
        {
          dependencies: [".phone#value", ".phone#valid"],
          fulfill: {
            state: {
              "component[1].readyPost": "{{$deps[0] && $deps[1]}}",
              "component[1].phoneNumber": "{{$deps[0]}}",
            },
          },
        },
      ],
    },
  },
};
const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    CodeInput,
  },
});
function VerifyCode({ phone }) {
  const auth = useAuthContext();
  const dispatch = useDispatch();
  const normalForm = createForm({
    validateFirst: true,
    initialValues: { phone },
  });
  const verifyHandler = useCallback(
    (values) => {
      userService.verifyCode(values, auth.token).then((res) => {
        if (res.result === true) {
          dispatch.user.updateUser({ ...auth, is_original: true });
        } else {
          message.error("验证码不正确，请重新完善信息");
          dispatch.user.logout();
        }
      });
    },
    [auth, dispatch]
  );

  return (
    <div className={styles.profileContainer}>
      <Card title="手机二次验证" bordered={false} className="profile-form">
        <Form
          form={normalForm}
          labelCol={8}
          wrapperCol={14}
          onAutoSubmit={verifyHandler}
        >
          <SchemaField schema={normalSchema} scope={{ token: auth.token }} />
          <FormButtonGroup.FormItem>
            <Space size="large">
              <Submit>确认</Submit>
              <Link to={"/"}>重新登录</Link>
            </Space>
          </FormButtonGroup.FormItem>
        </Form>
      </Card>
    </div>
  );
}
export default VerifyCode;
